import React ,{ Component } from "react";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withSnackbar } from 'notistack';
import { isMobileOnly, isMobile, isTablet } from 'react-device-detect';
import { startLoadingAnimate, stopLoadingAnimate } from "services/ducks/loading";
import { Row, Col } from "react-bootstrap";
import * as FontAwesome from '@fortawesome/react-fontawesome';
import { format } from "date-fns";
import { Button, Slider, Paper, TableContainer, Table, TableBody, TableHead, TableRow, TableCell, TextField, MenuItem, Modal } from "@material-ui/core";
import { faPlusSquare, faSave } from '@fortawesome/free-regular-svg-icons';
import { faUserEdit, faUserTimes, faUserPlus, faPercentage } from '@fortawesome/free-solid-svg-icons';
import { ContainerTitle, SessionTitle, FullSizedButton } from '../styles';
import { DeclaracaoSubtitle, ModalCloseButton, ModalSessionTitle, ModalBody, BoxButtonModal } from './styles'
import { InputCpf, DatePicker } from "components";
import { addOffsetToDate } from 'services/structure/dateUtils';
import SweetAlert from 'react-bootstrap-sweetalert';
import api from "services/structure/api";

class Beneficiarios extends Component {

    TOTAL_PERCENTUAL_PARTICIPACAO = 100;

    beneficiarioInitialState = {
        nome: "",
        cpf: "",
        dtNascimento: 0,
        sexo: "M",
        tipoDependencia: 1,
        estudante: true,
        invalido: false,
        percentualParticipacao: 0,
        action: 1,
    }

    state = {
        openIncluirBeneficiario: false,
        edicaoBeneficiarioPlano: false,
        edicaoDependenteIR: false,
        openChangePercentualParticipacao: false,
        beneficiarioEdicao: { ...this.beneficiarioInitialState },
        beneficiarioEdicaoError: {
            nome: false,
            cpf: false,
            dtNascimento: false,
        },
        beneficiarios: [],
        regrasExibicao: {
            exibirIncluirDependenteIR: false,
            exibirDependentesParaIR: false
        },
        tiposDependencia: [],
        idxBeneficiarioEdicao: null,
        removeBeneficiarioEdicao: false,
    }
    
    componentDidMount() {
         window.scrollTo(0, 0);
        let promises = [];

        this.props.startLoadingAnimate();
        let beneficiariosPromise = this.buscarBeneficiarios();
        const regrasExibicaoPromise = this.buscarRegrasExibicao();
        promises.push(beneficiariosPromise);
        let tiposDependenciaPromise = api.get("beneficiario/tipo-dependencia")
            .then(response => ({ tiposDependencia: response.data }))
            .catch(err => console.error(err));
        promises.push(tiposDependenciaPromise);
        promises.push(regrasExibicaoPromise);

        Promise.all(promises)
            .then( values => { 
                let newState = Object.assign(...values);
                this.beneficiarioInitialState.tipoDependencia = newState.tiposDependencia[0].descricao;
                newState.beneficiarioEdicao = { ...this.beneficiarioInitialState}
                this.setState(newState);
            })
            .catch((e) => {
                const mensagem = "Não foi possível conectar-se ao servidor. Recarregue a página! " ;
                this.props.enqueueSnackbar(mensagem, { variant: 'error' });
            }).finally(() => this.props.stopLoadingAnimate());
    }

    buscarBeneficiarios() {
        return api.get("beneficiario")
            .then(response => {
                const beneficiarios = response.data;
                 if (beneficiarios) {
                   beneficiarios.forEach(beneficiario => {
                        beneficiario.dtNascimento = this.dateConstructorFromTimestamp(beneficiario.dtNascimento);
                        beneficiario.action = 2; // UDPATE
                                        
                        let cpf = "000000"+beneficiario.cpf;
                        cpf = cpf.substring(cpf.length - 11);
                        cpf = cpf.replace(/\D/g, '');
                        beneficiario.cpf = cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4');
                    });
                 }
                return { beneficiarios: beneficiarios };
            })
            .catch(err => console.error(err));
    }

    buscarRegrasExibicao() {
        return api.get("meu-plano/regras-exibicao")
          .then(response => {
            const { exibirIncluirDependenteIR, exibirDependentesParaIR } = response.data;
            return { regrasExibicao: { exibirIncluirDependenteIR, exibirDependentesParaIR }};
          })
          .catch((err) => console.error(err));
      }

    dateConstructorFromTimestamp = timestamp => {
        if (!timestamp) {
            return null;
        }
        return new Date(timestamp);
    }

    editBeneficiario(beneficiario) {
        const idx = this.state.beneficiarios.findIndex(b => b === beneficiario);
        this.setState({ 
            beneficiarioEdicao: beneficiario, 
            idxBeneficiarioEdicao: idx, 
            openIncluirBeneficiario: true, 
            edicaoDependenteIR: false, 
            edicaoBeneficiarioPlano: true
        })
    }
    
    editDependenteIR(beneficiario) {
        const idx = this.state.beneficiarios.findIndex(b => b === beneficiario);
        this.setState({ 
            beneficiarioEdicao: beneficiario, 
            idxBeneficiarioEdicao: idx, 
            openIncluirBeneficiario: true, 
            edicaoDependenteIR: true, 
            edicaoBeneficiarioPlano: false
        })
    }

    removeBeneficiarioPlano = (beneficiario) => {
        beneficiario.beneficiarioPlano = false;
        this.setState({removeBeneficiarioEdicao: false, beneficiarioEdicao: { ...this.beneficiarioInitialState}});
        this.changePercentualParticipacao (beneficiario, 0);
        this.removeBeneficiario(beneficiario, true);
    }

    removeDependenteIR = (beneficiario) => {
        beneficiario.dependenteIR = false;
        this.setState({ removeEdicaoDependenteIR: false , beneficiarioEdicao: { ...this.beneficiarioInitialState}});
        this.removeBeneficiario(beneficiario, false);    
    }

    removeBeneficiario = (beneficiario, showPercentualParticipacao) => {
        if (!beneficiario.beneficiarioPlano && !beneficiario.dependenteIR) {
            beneficiario.action = 3; // DELETE ON SERVER
        }
        const beneficiarios = this.state.beneficiarios.filter(b => b.action !== 3);
        if (showPercentualParticipacao && beneficiarios.length > 1) {
            this.showPercentualParticipacaoModal();
            return;
        }
        if (beneficiarios.length === 1) {
            for(let i = 0; i < beneficiarios.length; i++) {
                beneficiarios[i].percentualParticipacao = this.TOTAL_PERCENTUAL_PARTICIPACAO;
            }
        }
        this.savePercentualParticipacao(beneficiarios);
    }
    
    changeAttributeBeneficiario = (key, value, err) => {
        const newState = {
            ...this.state.beneficiarioEdicao,
            [key]: value
        }
        const newErrorState = {
            ...this.state.beneficiarioEdicaoError,
            [key]: !!err
        }
        this.setState({ 
            beneficiarioEdicao: newState,
            beneficiarioEdicaoError: newErrorState
        });
    }

    changeCpf = (value) => {
        if (value?.length === 14) {
            const idx = this.state.beneficiarios.findIndex(b => b.cpf === value);
            if (idx >= 0) {
                const beneficiario = this.state.beneficiarios[idx];
                beneficiario.beneficiarioPlano |= this.state.beneficiarioEdicao.beneficiarioPlano
                beneficiario.dependenteIR |= this.state.beneficiarioEdicao.dependenteIR
                this.setState({ 
                    beneficiarioEdicao: beneficiario,
                    idxBeneficiarioEdicao: idx
                });
                return;
            }
        }
        this.changeAttributeBeneficiario("cpf", value);
    }

    onClickPercentualParticipacaoSlider = () => {  
        this.showPercentualParticipacaoModal();
    }

    showPercentualParticipacaoModal = () => {
        if (this.state.beneficiarios.length > 1) {
            this.setState( { openChangePercentualParticipacao: true } );
            return true;
        }
        return false;
    }

    showConfirmRemoveBeneficiario = (beneficiario) => {
        this.setState({ beneficiarioEdicao: beneficiario, removeBeneficiarioEdicao: true } );
    }

    showConfirmRemoveDependenteIR = (dependenteIR) => {
        this.setState({ beneficiarioEdicao: dependenteIR, removeEdicaoDependenteIR: true } );
    }

    // TODO separar em outro componente
    renderGridRowBeneficiarioPlanoDesktop = (beneficiario) => {
        return (    
            <TableRow key={beneficiario.cpf}>
                <TableCell align="left">
                    <Button type="submit" className="beneficiarios-editar editar" 
                        onClick={() => this.editBeneficiario(beneficiario)}>
                        <FontAwesome.FontAwesomeIcon icon={faUserEdit} className="beneficiarios-editar-icon"/> 
                    </Button> 
                </TableCell>
                <TableCell>{beneficiario.nome}</TableCell>
                <TableCell><nobr>{beneficiario.cpf}</nobr></TableCell>
                <TableCell><nobr>{format(addOffsetToDate(beneficiario.dtNascimento), 'dd/MM/yyyy')}</nobr></TableCell>
                <TableCell>{beneficiario.sexo}</TableCell>
                <TableCell><nobr>{beneficiario.tipoDependencia}</nobr></TableCell>
                <TableCell>{beneficiario.estudante ? "Sim" : "Não"}</TableCell>
                <TableCell>{beneficiario.invalido ? "Sim" : "Não"}</TableCell>
                <TableCell>
                    <span className="percentual-participacao" onClick={this.onClickPercentualParticipacaoSlider}>{beneficiario.percentualParticipacao}%</span> 
                </TableCell>
                <TableCell><nobr>{beneficiario.dtInscricao ? format(addOffsetToDate(beneficiario.dtInscricao), 'dd/MM/yyyy') : '-'}</nobr></TableCell>
                <TableCell><nobr>{beneficiario.dtUltimaAtualizacao ? format(addOffsetToDate(beneficiario.dtUltimaAtualizacao), 'dd/MM/yyyy') : '-'}</nobr></TableCell>
                <TableCell>
                    <Button type="submit" className="beneficiarios-excluir excluir" 
                        onClick={() => this.showConfirmRemoveBeneficiario(beneficiario)}>
                        <FontAwesome.FontAwesomeIcon icon={faUserTimes} className="beneficiarios-excluir-icon"/> 
                    </Button> 
                </TableCell>
            </TableRow>
        )
    }

    renderBeneficiariosPlanoRows(beneficiariosPlano, renderRow) {
        const rows = [];
        for (let idx = 0; idx < beneficiariosPlano.length; idx++) {
            let beneficiario = beneficiariosPlano[idx];
            if (beneficiario) {
                rows.push(renderRow(beneficiario));
            }
        }
        return rows;
    }

    renderGridNenhumBeneficiarioEncontrado = () => {
        return (
            <TableContainer component={Paper} className="table-beneficiarios">
                <Table size="small">
                    <TableHead>
                    <TableRow key={"sem-benef"}>
                        <TableCell>Nenhum beneficiário encontrado.</TableCell>
                    </TableRow>
                    </TableHead>
                </Table>
            </TableContainer>   )
    }

    getOnlyBeneficiarios = () => this.state.beneficiarios.filter(b => b.beneficiarioPlano);
    getOnlyDependentesIR = () => this.state.beneficiarios.filter(b => b.dependenteIR);

    renderGridBeneficiarios() {
        if (!this.state.beneficiarios || !this.state.beneficiarios.length) {
            return this.renderGridNenhumBeneficiarioEncontrado();
        }
        const beneficiariosPlano = this.getOnlyBeneficiarios();
        if (!beneficiariosPlano.length) {
            return this.renderGridNenhumBeneficiarioEncontrado();
        }
        if (isTablet) {
            return this.renderGridBeneficiariosTablet(beneficiariosPlano)
        }
        if (isMobile) {
            return this.renderGridBeneficiariosMobile(beneficiariosPlano)
        }
        return this.renderGridBeneficiariosDesktop(beneficiariosPlano)
    }

    renderGridBeneficiariosDesktop(beneficiariosPlano) {
        return (
            <TableContainer component={Paper} className="table-beneficiarios">
                <Table size="small" key={"tabela-benef-dektop"}>
                    <TableHead key={"tabela-benef-desktop-internal"}>
                        <TableRow key={"tabela-nome-colunas"}>
                            <TableCell>Editar</TableCell>
                            <TableCell>Nome</TableCell>
                            <TableCell>CPF</TableCell>
                            <TableCell>Nascimento</TableCell>
                            <TableCell>Sexo</TableCell>
                            <TableCell>Parentesco</TableCell>
                            <TableCell>Estudante</TableCell>
                            <TableCell>Inválido</TableCell>
                            <TableCell>% Participação</TableCell>
                        <TableCell>Dt inscrição</TableCell>
                        <TableCell>Última atualização</TableCell>
                            <TableCell>Excluir</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody> 
                        { this.renderBeneficiariosPlanoRows(beneficiariosPlano, this.renderGridRowBeneficiarioPlanoDesktop) }
                    </TableBody>
                </Table>
            </TableContainer>
        )
    }

    renderGridRowDependenteIRDesktop = (beneficiario) => {
        return (    
            <TableRow key={beneficiario.cpf}>
                <TableCell align="left">
                    <Button type="submit" className="dependente-ir-editar editar" 
                        onClick={() => this.editDependenteIR(beneficiario)}>
                        <FontAwesome.FontAwesomeIcon icon={faUserEdit} className="dependente-ir-editar-icon"/> 
                    </Button> 
                </TableCell>
                <TableCell>{beneficiario.nome}</TableCell>
                <TableCell>{beneficiario.cpf}</TableCell>
                <TableCell>{format(addOffsetToDate(beneficiario.dtNascimento), 'dd/MM/yyyy')}</TableCell>
                <TableCell>{beneficiario.sexo}</TableCell>
                <TableCell>{beneficiario.dtInscricao ? format(addOffsetToDate(beneficiario.dtInscricao), 'dd/MM/yyyy') : '-'}</TableCell>
                <TableCell>{beneficiario.dtUltimaAtualizacao ? format(addOffsetToDate(beneficiario.dtUltimaAtualizacao), 'dd/MM/yyyy') : '-'}</TableCell>
                <TableCell>
                    <Button type="submit" className="dependente-ir-excluir excluir" 
                        onClick={() => this.showConfirmRemoveDependenteIR(beneficiario)}>
                        <FontAwesome.FontAwesomeIcon icon={faUserTimes} className="dependente-ir-excluir-icon"/> 
                    </Button> 
                </TableCell>
            </TableRow>
        )
    }

    renderGridBeneficiariosMobile(beneficiariosPlano) {
        let rows = this.renderBeneficiariosPlanoRows(beneficiariosPlano, this.renderGridRowBeneficiarioPlanoMobile);
        return <div className='grid-beneficiarios-mobile'>{rows}</div>;
    }

    renderGridRowBeneficiarioPlanoMobile = (beneficiario) => {
        return (
            <div className="grid-beneficiarios-row">
                <Row>
                    <Col sm={1}>
                        <div className='card-row'>
                            <div className='card-cell nome'>
                                <div className="card-cell-title">Nome </div>
                                <div className="card-cell-value">{beneficiario.nome}</div>
                            </div>
                        </div>
                    </Col>
                </Row>
                {/* <Row className="line-separator"></Row> */}
                <Row>
                    <Col className="editar">
                        <div className="card-button">
                            <div className='card-cell-title'>Editar</div>
                            <div className="card-cell-value">
                                <Button type="submit" className="dependente-ir-editar" 
                                        onClick={() => this.editDependenteIR(beneficiario)}>
                                    <FontAwesome.FontAwesomeIcon icon={faUserEdit} className="dependente-ir-editar-icon"/> 
                                </Button>
                            </div>
                        </div>
                    </Col>
                    <Col className="excluir">
                        <div className="card-button">
                            <div className='card-cell-title'>Excluir</div>
                            <div className="card-cell-value">
                                <Button type="submit" className="dependente-ir-excluir" 
                                    onClick={() => this.showConfirmRemoveDependenteIR(beneficiario)}>
                                    <FontAwesome.FontAwesomeIcon icon={faUserTimes} className="dependente-ir-excluir-icon"/> 
                                </Button> 
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className='card-row'>
                            <div className='card-cell cpf'>
                                <div className="card-cell-title">CPF</div>
                                <div className="card-cell-value">{beneficiario.cpf}</div>
                            </div>
                        </div>
                    </Col>
                    <Col>
                        <div className='card-row'>
                            <div className='card-cell parentesco'>
                                <div className="card-cell-title">Parentesco</div>
                                <div className="card-cell-value">{beneficiario.tipoDependencia}</div>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className='card-row'>
                            <div className='card-cell data-nascimento'>
                                <div className="card-cell-title ">Nascimento</div>
                                <div className="card-cell-value">{format(addOffsetToDate(beneficiario.dtNascimento), 'dd/MM/yyyy')}</div>
                            </div>
                        </div>
                    </Col>
                    <Col>
                        <div className='card-row'>
                            <div className='card-cell estudante'>	
                                <div className="card-cell-title">Estudante</div>
                                <div className="card-cell-value">{beneficiario.estudante ? "Sim" : "Não"}</div>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className='card-row'>
                            <div className='card-cell sexo'>
                                <div className="card-cell-title">Sexo</div>
                                <div className="card-cell-value">{beneficiario.sexo}</div>
                            </div>
                        </div>
                    </Col>
                    <Col>
                        <div className='card-row'>
                            <div className='card-cell invalido'>
                                <div className="card-cell-title">Inválido</div>
                                <div className="card-cell-value">{beneficiario.invalido ? "Sim" : "Não"}</div>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col sm={1}>
                        <div className='card-row'>
                            <div className='card-cell participacao'>	
                                <div className="card-cell-title">% Participação</div>
                                <div className="card-cell-value">
                                    <span className="percentual-participacao" onClick={this.onClickPercentualParticipacaoSlider}>{beneficiario.percentualParticipacao}%</span> 
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        )
    }

    renderGridBeneficiariosTablet(beneficiariosPlano) {
        let rows = this.renderBeneficiariosPlanoRows(beneficiariosPlano, this.renderGridRowBeneficiarioPlanoTablet);
        return <div className='grid-beneficiarios-tablet'>{rows}</div>;
    }

    renderGridRowBeneficiarioPlanoTablet = (beneficiario) => {
        return (   
                <Row className="grid-beneficiarios-row">
                    <Col sm={1} className="card-button editar">
                        <div className='card-cell-title'>Editar</div>
                        <div className="card-cell-value">
                            <Button type="submit" className="dependente-ir-editar" 
                                    onClick={() => this.editDependenteIR(beneficiario)}>
                                <FontAwesome.FontAwesomeIcon icon={faUserEdit} className="dependente-ir-editar-icon"/> 
                            </Button>
                        </div>
                    </Col>
                    <Col sm={10}>
                        <div className='card-row'>
                            <div className='card-cell nome'>
                                <div className="card-cell-title">Nome </div>
                                <div className="card-cell-value">{beneficiario.nome}</div>
                            </div>
                            <div className='card-cell cpf'>
                                <div className="card-cell-title">CPF</div>
                                <div className="card-cell-value">{beneficiario.cpf}</div>
                            </div>
                            <div className='card-cell data-nascimento'>
                                <div className="card-cell-title ">Nascimento</div>
                                <div className="card-cell-value">{format(addOffsetToDate(beneficiario.dtNascimento), 'dd/MM/yyyy')}</div>
                            </div>
                            <div className='card-cell sexo'>
                                <div className="card-cell-title">Sexo</div>
                                <div className="card-cell-value">{beneficiario.sexo}</div>
                            </div>
                        </div>
                        <div className='card-row'>
                            <div className='card-cell parentesco'>
                                <div className="card-cell-title">Parentesco</div>
                                <div className="card-cell-value">{beneficiario.tipoDependencia}</div>
                            </div>
                            <div className='card-cell estudante'>	
                                <div className="card-cell-title">Estudante</div>
                                <div className="card-cell-value">{beneficiario.estudante ? "Sim" : "Não"}</div>

                            </div>
                            <div className='card-cell invalido'>
                                <div className="card-cell-title">Inválido</div>
                                <div className="card-cell-value">{beneficiario.invalido ? "Sim" : "Não"}</div>
                            </div>
                            <div className='card-cell participacao'>	
                                <div className="card-cell-title">% Participação</div>
                                <div className="card-cell-value">
                                    <span className="percentual-participacao" onClick={this.onClickPercentualParticipacaoSlider}>{beneficiario.percentualParticipacao}%</span> 
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col sm={1} className="card-button excluir">
                        <div className='card-cell-title'>Excluir</div>
                        <div className="card-cell-value">
                            <Button type="submit" className="dependente-ir-excluir" 
                                onClick={() => this.showConfirmRemoveDependenteIR(beneficiario)}>
                                <FontAwesome.FontAwesomeIcon icon={faUserTimes} className="dependente-ir-excluir-icon"/> 
                            </Button> 
                        </div>
                    </Col>
                </Row>
        )
    }

    renderDependentesIRRows (dependentesIRPlano, renderRow) {
        const rows = [];
        for (let idx = 0; idx < dependentesIRPlano.length; idx++) {
            rows.push(renderRow(dependentesIRPlano[idx]));
        }
        return rows;
    }

    renderGridNenhumDependenteEncontrado = () => {
        return <TableContainer component={Paper} className="table-beneficiarios">
            <Table size="small">
                <TableHead>
                <TableRow key="tabela-vazia">
                    <TableCell>Nenhum dependente para IR encontrado.</TableCell>
                </TableRow>
                </TableHead>
            </Table>
        </TableContainer>
    }

    renderGridDependentesIR () {
        if (!this.state.beneficiarios || !this.state.beneficiarios.length) {
            return this.renderGridNenhumDependenteEncontrado();
        }
        const dependentesIRPlano = this.getOnlyDependentesIR();
        if (!dependentesIRPlano.length) {
            return this.renderGridNenhumDependenteEncontrado();
        }
        if (isTablet) {
            return this.renderGridDependentesIRTablet(dependentesIRPlano);
        }
        if (isMobile) {
            return this.renderGridDependentesIRMobile(dependentesIRPlano);
        }
        return this.renderGridDependentesIRDesktop(dependentesIRPlano);
    }
    
    renderGridDependentesIRMobile(dependentesIRPlano) {
        return (
            <div className='grid-dependentes-ir-mobile'>
                {this.renderDependentesIRRows(dependentesIRPlano, this.renderDependentesIRRowsMobile)}
            </div>
        )
    }

    renderDependentesIRRowsMobile = (dependenteIR) => {
        return (
            <div className="grid-dependente-ir-row">
                <Row>
                    <Col>
                            <div className='card-cell nome'>
                                <div className="card-cell-title">Nome </div>
                                <div className="card-cell-value">{dependenteIR.nome}</div>
                            </div>
                    </Col>
                </Row>
                {/* <Row className="line-separator"></Row> */}
                <Row>
                    <Col className="card-button editar">
                        <div className='card-cell-title'>Editar</div>
                        <div className="card-cell-value">
                            <Button type="submit" className="dependente-ir-editar" 
                                    onClick={() => this.editDependenteIR(dependenteIR)}>
                                <FontAwesome.FontAwesomeIcon icon={faUserEdit} className="dependente-ir-editar-icon"/> 
                            </Button>
                        </div>
                    </Col>
                    <Col className="card-button excluir">
                        <div className='card-cell-title'>Excluir</div>
                        <div className="card-cell-value">
                            <Button type="submit" className="dependente-ir-excluir" 
                                onClick={() => this.showConfirmRemoveDependenteIR(dependenteIR)}>
                                <FontAwesome.FontAwesomeIcon icon={faUserTimes} className="dependente-ir-excluir-icon"/> 
                            </Button> 
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className='card-row'>
                            <div className='card-cell cpf'>
                                <div className="card-cell-title">CPF</div>
                                <div className="card-cell-value">{dependenteIR.cpf}</div>
                            </div>
                            <div className='card-cell data-nascimento'>
                                <div className="card-cell-title">Nascimento</div>
                                <div className="card-cell-value">{format(addOffsetToDate(dependenteIR.dtNascimento), 'dd/MM/yyyy')}</div>
                            </div>
                            <div className='card-cell sexo'>
                                <div className="card-cell-title">Sexo</div>
                                <div className="card-cell-value">{dependenteIR.sexo}</div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        )
    }

    renderGridDependentesIRTablet(dependentesIRPlano) {
        return (
            <div className='grid-dependentes-ir-tablet'>
                {this.renderDependentesIRRows(dependentesIRPlano, this.renderDependentesIRRowsTablet)}
            </div>
        )
    }

    renderDependentesIRRowsTablet = (dependenteIR) => {
        return (
            <Row className="grid-dependente-ir-row">
                <Col sm={1} className="card-button editar">
                    <div className='card-cell-title'>Editar</div>
                    <div className="card-cell-value">
                        <Button type="submit" className="dependente-ir-editar" 
                                onClick={() => this.editDependenteIR(dependenteIR)}>
                            <FontAwesome.FontAwesomeIcon icon={faUserEdit} className="dependente-ir-editar-icon"/> 
                        </Button>
                    </div>
                </Col>
                <Col sm={10}>
                    <div className='card-row'>
                        <div className='card-cell nome'>
                            <div className="card-cell-title">Nome </div>
                            <div className="card-cell-value">{dependenteIR.nome}</div>
                        </div>
                        <div className='card-cell cpf'>
                            <div className="card-cell-title">CPF</div>
                            <div className="card-cell-value">{dependenteIR.cpf}</div>
                        </div>
                        <div className='card-cell data-nascimento'>
                            <div className="card-cell-title">Nascimento</div>
                            <div className="card-cell-value">{format(addOffsetToDate(dependenteIR.dtNascimento), 'dd/MM/yyyy')}</div>
                        </div>
                        <div className='card-cell sexo'>
                            <div className="card-cell-title">Sexo</div>
                            <div className="card-cell-value">{dependenteIR.sexo}</div>
                        </div>
                    </div>
                </Col>
                <Col sm={1} className="card-button excluir">
                    <div className='card-cell-title'>Excluir</div>
                    <div className="card-cell-value">
                        <Button type="submit" className="dependente-ir-excluir" 
                            onClick={() => this.showConfirmRemoveDependenteIR(dependenteIR)}>
                            <FontAwesome.FontAwesomeIcon icon={faUserTimes} className="dependente-ir-excluir-icon"/> 
                        </Button> 
                    </div>
                </Col>
            </Row>
        )
    }

    renderGridDependentesIRDesktop(dependentesIRPlano) {
        return (
            <TableContainer component={Paper} className="table-beneficiarios">
                <Table size="small">
                    <TableHead>
                    <TableRow key={dependentesIRPlano.cpf}>
                        <TableCell>Editar</TableCell>
                        <TableCell>Nome</TableCell>
                        <TableCell>CPF</TableCell>
                        <TableCell>Nascimento</TableCell>
                        <TableCell>Sexo</TableCell>
                        <TableCell>Dt inscrição</TableCell>
                        <TableCell>Última atualização</TableCell>
                        <TableCell>Excluir</TableCell>
                    </TableRow>
                    </TableHead>
                    <TableBody> 
                        { this.renderDependentesIRRows(dependentesIRPlano, this.renderGridRowDependenteIRDesktop) }
                    </TableBody>
                </Table>
            </TableContainer>
        )
    }

    validateBeneficiarioEdicao = () => {
        let failed = false;
        let errors = {
            nome: false,
            cpf: false,
            dtNascimento: false,
        }

        if (!this.state.beneficiarioEdicao.nome) {
            failed = true;
            errors.nome = true;
            this.props.enqueueSnackbar("O nome é obrigatório!", { variant: 'error' });
        }

        if (!this.state.beneficiarioEdicao.cpf || this.state.beneficiarioEdicao.cpf.length < 14) {
            failed = true;
            errors.cpf = true;
            this.props.enqueueSnackbar("CPF válido é obrigatório!", { variant: 'error' });
        }

        if (!this.state.beneficiarioEdicao.dtNascimento) { 
            failed = true;
            errors.dtNascimento = true;
            this.props.enqueueSnackbar("Data de nascimento é obrigatória!", { variant: 'error' });
        }
        
        if (this.state.edicaoBeneficiarioPlano && !this.state.beneficiarioEdicao.tipoDependencia) { 
            failed = true;
            errors.dtNascimento = true;
            this.props.enqueueSnackbar("Parentesco é obrigatório!", { variant: 'error' });
        }

        if (failed) {
            this.setState({ beneficiarioEdicaoError : errors });
        }

        return !failed;
    }

    saveBeneficiarios = () => {
        if (!this.validateBeneficiarioEdicao()) {
            return;
        }
        const beneficiarios = this.state.beneficiarios;
        const beneficiarioEdicao = this.state.beneficiarioEdicao;
        if (this.state.idxBeneficiarioEdicao == null) {
            beneficiarios.push(beneficiarioEdicao);
            
            if (beneficiarios.length === 1) {
                beneficiarioEdicao.percentualParticipacao = this.TOTAL_PERCENTUAL_PARTICIPACAO;
            }
        } else {
            beneficiarios[this.state.idxBeneficiarioEdicao] = beneficiarioEdicao;
        }
        beneficiarioEdicao.dependenteIR |= this.state.edicaoDependenteIR;
        beneficiarioEdicao.beneficiarioPlano |= this.state.edicaoBeneficiarioPlano;

        this.clearEditData();

        if (!this.state.edicaoBeneficiarioPlano || !this.showPercentualParticipacaoModal()) {
            this.requestSaveOnServer();
        }
    }

    clearEditData = () => {
        this.setState({ 
            openIncluirBeneficiario: false, 
            beneficiarios: this.state.beneficiarios, 
            beneficiarioEdicao: {...this.beneficiarioInitialState},
            idxBeneficiarioEdicao: null,
            edicaoDependenteIR: false,
            edicaoBeneficiarioPlano: false,
        });
    }

    requestSaveOnServer = async () => {
        try {
            this.props.startLoadingAnimate();
            await api.put("beneficiario", this.state.beneficiarios);
            const beneficiarios = await this.buscarBeneficiarios();
            this.setState(beneficiarios);
            
            const mensagem = "Sua lista de beneficiários e dependentes foi atualizada com sucesso! " ;
            this.props.enqueueSnackbar(mensagem, { variant: 'success' });
        } catch (e) {
            const mensagem = "Não foi possível conectar-se ao servidor. Recarregue a página! " ;
            this.props.enqueueSnackbar(mensagem, { variant: 'error' });
        } finally {
            this.props.stopLoadingAnimate();
        }
    }

    openEdicaoBeneficiarioPlanoNovo = () => {
        this.setState( { openIncluirBeneficiario : true, edicaoDependenteIR : false, edicaoBeneficiarioPlano : true, idxBeneficiarioEdicao: null } );
    }
    openEdicaoDependenteIRPlanoNovo = () => {
        this.setState( { openIncluirBeneficiario : true, edicaoDependenteIR : true, edicaoBeneficiarioPlano: false, idxBeneficiarioEdicao: null } );
    }

    closeEdicaoBeneficiarioPlano = async () => {
        this.clearEditData();
        
        this.props.startLoadingAnimate();
        const beneficiarios = await this.buscarBeneficiarios();
        this.setState(beneficiarios);
        this.props.stopLoadingAnimate();
    }

    closeEdicaoPercentuaisParticipacao = async () => {
        this.setState({
            openChangePercentualParticipacao: false, 
        })

        this.props.startLoadingAnimate();
        const beneficiarios = await this.buscarBeneficiarios();
        this.setState(beneficiarios);
        this.props.stopLoadingAnimate();
    }

    renderPercentualParticipacaoRows() {
        if (isMobileOnly) {
            return this.renderPercentualParticipacaoRowsMobile();
        }
        return this.renderPercentualParticipacaoRowsDesktop();
    }

    renderPercentualParticipacaoRowsMobile() {
        const beneficiariosPlano = this.state.beneficiarios.filter(b => b.beneficiarioPlano);
        const rows = [];
        for (let idx = 0; idx < beneficiariosPlano.length; idx++) {
            const beneficiario = beneficiariosPlano[idx];
            const row = (
                <div className="card-row-slider">
                    <Row className="card-item nome">
                        <Col sm={1}>
                            <b>
                                {beneficiario.nome}
                            </b>
                        </Col>
                    </Row>
                    <Row className="card-item slider-percentual-participacao">
                        <Col>
                            <span className="slider-component">
                                <Slider value={beneficiario.percentualParticipacao}  
                                    onChange={ (_, newValue) => this.changePercentualParticipacao(beneficiario, newValue) } 
                                    min={0} max={100}
                                /> 
                            </span>
                        </Col>
                        <Col>
                            <TextField 
                                variant="outlined"
                                margin="normal"
                                label="Percentual"
                                className="slider-percent-input"
                                onChange={e => this.changePercentualParticipacaoInput(beneficiario, e)}
                                value={beneficiario.percentualParticipacao + '%'}
                            />
                        </Col>
                    </Row>
                </div>
            );
            rows.push(row);
        }
        return rows;
    }

    renderPercentualParticipacaoRowsDesktop() {
        const beneficiariosPlano = this.state.beneficiarios.filter(b => b.beneficiarioPlano);
        const rows = [];
        for (let idx = 0; idx < beneficiariosPlano.length; idx++) {
            const beneficiario = beneficiariosPlano[idx];
            const row = (
                <TableRow key={beneficiario.cpf}>
                    <TableCell>{beneficiario.nome}</TableCell>
                    <TableCell className="slider-component-col">
                        <span className="slider-component">
                            <Slider value={beneficiario.percentualParticipacao}  
                                onChange={ (_, newValue) => this.changePercentualParticipacao(beneficiario, newValue) } 
                                min={0} max={100}
                            /> 
                        </span>
                    </TableCell>
                    <TableCell className="slider-percent-input-col">
                        <TextField 
                            variant="outlined"
                            margin="normal"
                            label="Percentual"
                            className="slider-percent-input"
                            onChange={e => this.changePercentualParticipacaoInput(beneficiario, e)}
                            value={beneficiario.percentualParticipacao + '%'}
                        />
                    </TableCell>
                </TableRow>);
            rows.push(row);
        }
        return (
            <TableContainer component={Paper} className="table-beneficiarios-percentuais-participacao"> 
                <Table>
                    <TableHead size="small">
                        <TableRow  key={"tabela-benef-ir-participacao"}>
                            <TableCell>Nome</TableCell>
                            <TableCell>Percentual de participação</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows}
                    </TableBody>
                </Table>
            </TableContainer>
        );
    }

    changePercentualParticipacao = (beneficiario, newValue) => {
        beneficiario.percentualParticipacao = newValue;
        this.setState({ beneficiarios: this.state.beneficiarios });
    }

    changePercentualParticipacaoInput = (beneficiario, event) => {
        if (event.target.value) {
            beneficiario.percentualParticipacao = parseFloat('0' + event.target.value.replace('%', '')) ;
            this.setState({ beneficiarios: this.state.beneficiarios });
        }
    }

    obterBeneficiariosPlano = () => this.state.beneficiarios.filter(b => b.beneficiarioPlano);

    savePercentualParticipacao = beneficiarios => {
        const totalPercentualParticipacao = beneficiarios.map(b => b.percentualParticipacao).reduce( (total, currval) => total + currval, 0);
        if (beneficiarios.length > 0 && totalPercentualParticipacao !== this.TOTAL_PERCENTUAL_PARTICIPACAO) {
            const mensagem = `O total dos percentuais de participação deve ser ${this.TOTAL_PERCENTUAL_PARTICIPACAO}%! ` ;
            this.props.enqueueSnackbar(mensagem, { variant: 'error' });
            return;
        }

        if (beneficiarios.filter(b => b.percentualParticipacao < 1).length > 0) {
            const mensagem = `Todos os participantes devem ter participação maior que 1%! ` ;
            this.props.enqueueSnackbar(mensagem, { variant: 'error' });
            return;
        }
        this.setState({ openChangePercentualParticipacao: false });
        this.requestSaveOnServer();
    }
    

    render() {
    let ultimaAtualizacaoCadastral = this.props.authData.usuario.pessoa.dtUltimaAtualizacaoCadastralBeneficiarios;
    if (ultimaAtualizacaoCadastral) {
            ultimaAtualizacaoCadastral = format(addOffsetToDate(new Date(ultimaAtualizacaoCadastral)), 'dd/MM/yyyy');
        } else {
            ultimaAtualizacaoCadastral = "Não Informado"
        }
        return (
            <div className="beneficiarios">
                <Row className="beneficiarios-title-container">
                    <Col sm={!isMobile ? 4 : 6}>
                        <ContainerTitle>BENEFICIÁRIOS </ContainerTitle>
                        <DeclaracaoSubtitle>
                            Mantenha os seus dados atualizados
                        </DeclaracaoSubtitle>
                        { isMobileOnly && <img src={process.env.PUBLIC_URL + '/beneficiarios-subtitle.png'} className="beneficiarios-subtitle" alt=""/> }
                        
                        <FullSizedButton 
                            type="submit" 
                            className="beneficiarios-open-incluir"
                            variant="contained"
                            onClick={this.openEdicaoBeneficiarioPlanoNovo}>
                            <FontAwesome.FontAwesomeIcon icon={faUserPlus} className="beneficiarios-open-incluir-icon"/> 
                            <span  className="beneficiarios-open-incluir-label">INCLUIR BENEFICIÁRIO</span>
                        </FullSizedButton>
                        { this.state.regrasExibicao.exibirIncluirDependenteIR ?
                            <FullSizedButton 
                                type="submit" 
                                className="dependente-ir-open-incluir"
                                variant="contained"
                                onClick={this.openEdicaoDependenteIRPlanoNovo}>
                                <FontAwesome.FontAwesomeIcon icon={faUserPlus} className="dependente-ir-incluir-icon"/> 
                                <span  className="dependente-ir-incluir-label">INCLUIR DEPENDENTE IR</span>
                            </FullSizedButton>
                        : null }
                    </Col>
                    <Col sm={!isMobile ? 8 : 6}>
                        { !isMobileOnly && <img src={process.env.PUBLIC_URL + '/beneficiarios-subtitle.png'} className="beneficiarios-subtitle" alt=""/> }
                    </Col>
                </Row>
                <SessionTitle>BENEFICIÁRIOS DO PLANO </SessionTitle>
                <div>
                    {this.renderGridBeneficiarios()}
                </div>
                <Row className="section-alterar-percentual-participacao">
                    <Col></Col>
                    <Col sm={!isMobile ? 5 : 7}>
                        <FullSizedButton type="submit" className="button-alterar-percentual-participacao" variant="contained"
                            disabled={this.state.beneficiarios.length <= 1}
                            onClick={this.onClickPercentualParticipacaoSlider} >
                            <FontAwesome.FontAwesomeIcon icon={faPercentage} className="beneficiarios-incluir-icon"/> 
                            <span  className="alterar-percentual-label">ALTERAR PERCENTUAL PARTICIPAÇÃO</span>
                        </FullSizedButton> 
                    </Col>
                    <Col></Col>
                </Row>
                { this.state.regrasExibicao.exibirDependentesParaIR ?
                    <><SessionTitle>DEPENDENTES PARA IR</SessionTitle>
                    <div>
                        {this.renderGridDependentesIR()}
                    </div></>
                : <div className="mb-5"></div> }

                <Modal open={this.state.openIncluirBeneficiario} onClose={this.clearEditData}>
                    <ModalBody >
                        { 
                            this.state.edicaoBeneficiarioPlano &&
                            <ModalSessionTitle>DIGITE OS DADOS DO BENEFICIÁRIO </ModalSessionTitle>
                        }
                        { 
                            !this.state.edicaoBeneficiarioPlano &&
                            <ModalSessionTitle>DIGITE OS DADOS DO DEPENDENTE DO IR </ModalSessionTitle>
                        }
                        <ModalCloseButton 
                            variant="contained" className="close-modal-button"
                            onClick={this.closeEdicaoBeneficiarioPlano}>X</ModalCloseButton>
                        <Row>
                            <Col sm={6}>
                                <InputCpf 
                                    variant="outlined"
                                    margin="normal"
                                    fullWidth
                                    required
                                    label="CPF"
                                    value={this.state.beneficiarioEdicao?.cpf}
                                    onChange={ (e) => this.changeCpf(e.target.value)}
                                    error={this.state.beneficiarioEdicaoError.cpf}
                                    name="cpf"/>
                            </Col>
                            <Col sm={6}>
                                <TextField 
                                    autoFocus
                                    variant="outlined"
                                    margin="normal"
                                    fullWidth
                                    required
                                    label="Nome"
                                    value={this.state.beneficiarioEdicao?.nome}
                                    onChange={ (e) => this.changeAttributeBeneficiario("nome", e.target.value)}
                                    error={this.state.beneficiarioEdicaoError.nome}
                                    name="Nome"/>
                            </Col>
                            <Col sm={6}>
                                <DatePicker
                                    variant="outlined"
                                    margin="normal"
                                    required
                                    fullWidth
                                    label="Nascimento"
                                    value={this.state.beneficiarioEdicao?.dtNascimento}
                                    onChange={ (date, err) => this.changeAttributeBeneficiario("dtNascimento", date, err)}
                                    error={this.state.beneficiarioEdicaoError.dtNascimento}
                                    name="dataNascimento"/>
                            </Col>
                            <Col sm={6}>
                                <TextField 
                                    variant="outlined"
                                    margin="normal"
                                    fullWidth
                                    label="Sexo"
                                    name="sexo"
                                    value={this.state.beneficiarioEdicao?.sexo}
                                    onChange={ (e) => this.changeAttributeBeneficiario("sexo", e.target.value)}
                                    select={true}>
                                    <MenuItem value="M">Masculino</MenuItem>
                                    <MenuItem value="F">Feminino</MenuItem>
                                </TextField>
                            </Col>
                            <Col sm={6}>
                                {   this.state.edicaoBeneficiarioPlano &&
                                    <TextField 
                                        variant="outlined"
                                        margin="normal"
                                        fullWidth
                                        label="Parentesco"
                                        name="parentesco"
                                        value={this.state.beneficiarioEdicao?.tipoDependencia}
                                        onChange={ (e) => this.changeAttributeBeneficiario("tipoDependencia", e.target.value)}
                                        select={true}>
                                        {this.state.tiposDependencia.map(function(object, i){
                                            return (<MenuItem value={object.descricao}>{object.descricao}</MenuItem>)
                                        })}
                                    </TextField>
                                }
                            </Col>
                            <Col sm={6}>
                                {   this.state.edicaoBeneficiarioPlano &&
                                    <TextField 
                                        variant="outlined"
                                        margin="normal"
                                        fullWidth
                                        label="Estudante"
                                        name="estudante"
                                        value={this.state.beneficiarioEdicao?.estudante}
                                        onChange={ (e) => this.changeAttributeBeneficiario("estudante", e.target.value)}
                                        select={true}>
                                        <MenuItem value={true}>Sim</MenuItem>
                                        <MenuItem value={false}>Não</MenuItem>
                                    </TextField>
                                }
                            </Col>
                            <Col sm={6}>
                                {   this.state.edicaoBeneficiarioPlano &&
                                    <TextField 
                                        variant="outlined"
                                        margin="normal"
                                        fullWidth
                                        label="Inválido"
                                        name="inválido"
                                        value={this.state.beneficiarioEdicao?.invalido}
                                        onChange={ (e) => this.changeAttributeBeneficiario("invalido", e.target.value)}
                                        select={true}>
                                        <MenuItem value={true}>Sim</MenuItem>
                                        <MenuItem value={false}>Não</MenuItem>
                                    </TextField>
                                }
                            </Col>
                            <Col sm={6}>
                                    <FullSizedButton type="submit" autoFocus className="beneficiarios-incluir" variant="contained"
                                        onClick={() => this.saveBeneficiarios()}>
                                        <FontAwesome.FontAwesomeIcon icon={faPlusSquare} className="beneficiarios-incluir-icon"/> 
                                        <span  className="beneficiarios-incluir-label"> 
                                        { 
                                            this.state.idxBeneficiarioEdicao === null ? ( 
                                                <span>
                                                    INCLUIR 
                                                    { this.state.edicaoBeneficiarioPlano ? ' BENEFICIÁRIO' : ' DEPENDENTE IR' } 
                                                </span>
                                            ) : (
                                                <span>SALVAR</span>
                                            )
                                        }
                                        </span>
                                    </FullSizedButton> 
                            </Col>
                        </Row>
                    </ModalBody>
                </Modal>
                <Modal open={this.state.openChangePercentualParticipacao} className="modal-percentual-participacao">
                    <ModalBody>
                        <ModalSessionTitle>PERCENTUAIS DE PARTICIPAÇÃO</ModalSessionTitle>

                        <ModalCloseButton 
                            variant="contained"
                            onClick={this.closeEdicaoPercentuaisParticipacao}>X</ModalCloseButton>
                        <p>
                            Você já possui outros beneficiários cadastrados. 
                            Edite seus percentuais de participação para garantir a 
                            distribuição correta do benefício. Lembre-se: a soma dos 
                            percentuais deve ser igual a 100%. 
                        </p>
                        <center>
                            {this.renderPercentualParticipacaoRows()}
                            <BoxButtonModal>
                                <FullSizedButton type="submit" className="beneficiarios-salvar" variant="contained"
                                    onClick={() => this.savePercentualParticipacao(this.obterBeneficiariosPlano())}>  
                                    <FontAwesome.FontAwesomeIcon icon={faSave} className="beneficiarios-salvar-icon"/> 
                                    <span  className="beneficiarios-salvar-label"> SALVAR ALTERAÇÕES </span>
                                </FullSizedButton> 
                            </BoxButtonModal>
                        </center>
                    </ModalBody>
                </Modal>
                
                {
                    this.state.removeBeneficiarioEdicao && 
                        <SweetAlert
                            warning
                            className="remove-beneficiario"
                            title="Atenção!"
                            onConfirm={() => this.removeBeneficiarioPlano(this.state.beneficiarioEdicao)}
                            confirmBtnText="Remover!"
                            confirmBtnBsStyle="danger"
                            showCancel
                            focusCancelBtn
                            onCancel={() => this.setState({ removeBeneficiarioEdicao: false , beneficiarioEdicao: { ...this.beneficiarioInitialState}})}
                            cancelBtnText="Cancelar!">
                                Tem certeza que deseja remover o beneficiário {this.state.beneficiarioEdicao?.nome}?
                        </SweetAlert>
                }

                {
                    this.state.removeEdicaoDependenteIR && 
                        <SweetAlert
                            warning
                            className="remove-dependente"
                            title="Atenção!"
                            onConfirm={() => this.removeDependenteIR(this.state.beneficiarioEdicao)}
                            confirmBtnText="Remover!"
                            confirmBtnBsStyle="danger"
                            showCancel
                            focusCancelBtn
                            onCancel={() => this.setState({ removeEdicaoDependenteIR: false , beneficiarioEdicao: { ...this.beneficiarioInitialState}})}
                            cancelBtnText="Cancelar!">
                                Tem certeza que deseja remover o dependente {this.state.beneficiarioEdicao?.nome}?
                        </SweetAlert>
                }
            </div>
        )
    }
}

const mapStateToProps = store => ({
    authData: store.authState
  });

const mapDispatchToProps = dispatch =>
  bindActionCreators({ startLoadingAnimate, stopLoadingAnimate }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps) (withRouter(withSnackbar(Beneficiarios)));